import { render, staticRenderFns } from "./PythonEditorHome.vue?vue&type=template&id=dc9dd8e6&scoped=true&"
import script from "./PythonEditorHome.vue?vue&type=script&lang=js&"
export * from "./PythonEditorHome.vue?vue&type=script&lang=js&"
import style0 from "./PythonEditorHome.vue?vue&type=style&index=0&id=dc9dd8e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9dd8e6",
  null
  
)

export default component.exports